module.exports = __webpack_public_path__ + "advisory-8c397925/feedback-197cedee9db8213138f8094043dfb7c1.jpeg";